import { defineMessages } from '@jutro/locale';

export default defineMessages({
    activityDetail: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Activity Detail',
        defaultMessage: 'Activity Detail'
    },
    closeModal: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.CLOSE',
        defaultMessage: 'CLOSE'
    },
    cancel: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.CANCEL',
        defaultMessage: 'CANCEL'
    },
    dueDate: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Due Date',
        defaultMessage: 'Due Date'
    },
    markActivityComplete: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.MARK ACTIVITY COMPLETE',
        defaultMessage: 'MARK ACTIVITY COMPLETE'
    },
    subject: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Subject',
        defaultMessage: 'Subject'
    },
    description: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Description',
        defaultMessage: 'Description'
    },
    initiator: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Initiator',
        defaultMessage: 'Initiator'
    },
    status: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Status',
        defaultMessage: 'Status'
    },
    priority: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Priority',
        defaultMessage: 'Priority'
    },
    assignedTo: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Assigned To',
        defaultMessage: 'Assigned To'
    },
    notes: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.Notes',
        defaultMessage: 'Notes'
    },
    notesDescription: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.notesTable.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    notesFullDescription: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.notesTable.FULL DESCRIPTION',
        defaultMessage: 'FULL DESCRIPTION'
    },
    notesCategory: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.notesTable.CATEGORY',
        defaultMessage: 'CATEGORY'
    },
    addANoteButton: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.ADD A NOTE',
        defaultMessage: '.ADD A NOTE'
    },
    saveBtn: {
        id: 'ml.gateway.views.ActivityReports.MLActivityDetailPopup.SAVE',
        defaultMessage: 'SAVE'
    },

    detailedSummary: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Detailed Summary',
        defaultMessage: 'Detailed Summary'
    },
    claimNumber: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Claim Number',
        defaultMessage: 'Claim #{number}'
    },
    claimStatus: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Claim Status',
        defaultMessage: 'Claim Status: {status}'
    },
    dateOfLoss: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Date of Loss',
        defaultMessage: 'Date of Loss:'
    },
    dateOfLossSubmitted: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Date of Loss Submitted',
        defaultMessage: 'Date of Loss Submitted:'
    },
    location: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Location',
        defaultMessage: 'Location'
    },
    detailedDescription: {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Description',
        defaultMessage: 'Description'
    },
    closeBtn : {
        id: 'ml.gateway.views.AccountClaims.DetailedSummary.Close',
        defaultMessage: 'Close'
    }
});
